import { render, staticRenderFns } from "./FunctionPopularityTable.vue?vue&type=template&id=7f840bbc"
import script from "./FunctionPopularityTable.vue?vue&type=script&lang=js"
export * from "./FunctionPopularityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports